import operationTypes from 'constants/operationTypes';

export const operationsWithoutNotarialRegistrationSection = [
  operationTypes.CONTRIBUTION,
];
